export const selectAllPrinters = state => state.printers.all
export const selectPrinterData = state => state.printers.data
export const selectGeneralData = state => state.printers.generalData
export const selectPrintLocalResponse = state => state.printers.local
export const selectPrintInstructions = state => state.printers.printInstructions
